<template>
	<div v-loading="loading" class="base_scroll_page">
		<!-- 滚动区域 -->
		<div class="b_scroller">
			<!-- action -->
			<div style="font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="名称"
					>
					</el-table-column>
					<el-table-column
						prop="productName"
						label="产品类型"
					>
					</el-table-column>
					<el-table-column
						prop="userTypeName"
						label="用户类型"
					>
					</el-table-column>
					<el-table-column
						prop="creatDate"
						label="创建时间"
					>
					</el-table-column>
					<el-table-column
						prop="remark"
						label="备注"
					>
					</el-table-column>
					<el-table-column
						prop="clearName"
						label="是否定时清除"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="200"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<!-- <div style="float: left;">
					<el-button type="danger" @click="handleDeleteClick">批量删除</el-button>
				</div> -->
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		<!-- 滚动区域 end -->
		
		<!-- 新增登录类型 -->
		<Popup 
			v-model="add_display"
			title="新增登录类型"
			confirmBtnText="添加"
			@confirmClick="handleAddPopupConfirmClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>名称</span>
					<el-input v-model="add_name" placeholder="名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addName_tip"><i class="b_icon"></i>请输入登录类型名称</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>产品类型</span>
					<el-select v-model="add_product_type" style="width: 100%;">
						<el-option :value="1" label="pc端"></el-option>
						<el-option :value="2" label="app"></el-option>
						<el-option :value="3" label="微信授权"></el-option>
						<el-option :value="4" label="扫码获取随机二维码"></el-option>
						<el-option :value="5" label="微信根据unionid登录"></el-option>
						<el-option :value="6" label="解析令牌"></el-option>
						<el-option :value="7" label="根据redis密令登录"></el-option>
					</el-select>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>用户类型</span>
					<el-select v-model="add_user_type" style="width: 100%;">
						<el-option :value="0" label="患者"></el-option>
						<el-option :value="1" label="非患者"></el-option>
					</el-select>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>是否定时清除</span>
					<div class="b_checkbox_group">
						<el-radio-group v-model="add_clear">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">备注</span>
					<el-input v-model="add_remark" placeholder="备注"></el-input>
				</div>
			</div>
		</Popup>
		<!-- 新增登录类型 end -->
		
		<!-- 修改登录类型 -->
		<Popup 
			v-model="update_display"
			title="修改登录类型"
			confirmBtnText="确定"
			@confirmClick="handleUpdatePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>名称</span>
					<el-input v-model="update_name" placeholder="名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateName_tip"><i class="b_icon"></i>请输入登录类型名称</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>产品类型</span>
					<el-select v-model="update_product_type" style="width: 100%;">
						<el-option :value="1" label="pc端"></el-option>
						<el-option :value="2" label="app"></el-option>
						<el-option :value="3" label="微信授权"></el-option>
						<el-option :value="4" label="扫码获取随机二维码"></el-option>
						<el-option :value="5" label="微信根据unionid登录"></el-option>
						<el-option :value="6" label="解析令牌"></el-option>
						<el-option :value="7" label="根据redis密令登录"></el-option>
					</el-select>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>用户类型</span>
					<el-select v-model="update_user_type" style="width: 100%;">
						<el-option :value="0" label="患者"></el-option>
						<el-option :value="1" label="非患者"></el-option>
					</el-select>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>是否定时清除</span>
					<div class="b_checkbox_group">
						<el-radio-group v-model="update_clear">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">备注</span>
					<el-input v-model="update_remark" placeholder="备注"></el-input>
				</div>
			</div>
		</Popup>
		<!-- 修改登录类型 end -->
		
		<!-- 删除弹出框 -->
		<Popup
			v-model="delete_display"
			title="提示"
			@confirmClick="handleDeletePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<p style="color: #5f6468;line-height: 24px;">您确认要删除该条吗？</p>
			</div>
		</Popup>
		<!-- 删除弹出框 end -->
	</div>
</template>

<script>
	import Api from '../../../../api/index.js';
	import BaseMethods from '../../../../assets/js/base.js';
	import { mapMutations } from 'vuex';
	
	export default {
		mounted () {
			this.do_msg = '';
			this.getList();
		},
		data () {
			return {
				loading: false,
				tableData: [],
				currentPage: 1,
				total: 0,
				
				add_display: false,
				add_name: '',
				add_product_type: 1,
				add_user_type: 0,
				add_clear: 0,
				add_remark: '',
				addName_tip: false,
				
				update_display: false,
				update_id: '',
				update_name: '',
				update_product_type: 1,
				update_user_type: 0,
				update_clear: 0,
				update_remark: '',
				updateName_tip: false,
				
				delete_display: false,
				delete_id: ''
			}
		},
		methods: {
			/********************************* @Events *********************************/
			// 点击新增
			handleAddClick () {
				this.add_name = '';
				this.add_product_type = 1;
				this.add_user_type = 0;
				this.add_clear = 0;
				this.add_remark = '';
				this.addName_tip = false;
				this.add_display = true;
			},
			// 点击新增弹出框确定按钮
			handleAddPopupConfirmClick () {
				if (!this.add_name.trim()) {
					this.addName_tip = true;
					return false;
				} else {
					this.addName_tip = false;
				}
				this.addLoginType();
			},
			
			// 页码改变
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},
			
			// 点击修改
			handleUpdateClick (obj) {
				this.update_id = obj.id;
				this.update_name = obj.name;
				this.update_product_type = obj.productType;
				this.update_user_type = obj.userType;
				this.update_clear = obj.clear;
				this.update_remark = obj.remark;
				this.updateName_tip = false;
				this.update_display = true;
			},
			// 点击修改弹出框确定按钮
			handleUpdatePopupConfirmClick () {
				const that = this;
				if (!this.update_name.trim()) {
					this.updateName_tip = true;
					return false;
				} else {
					this.updateName_tip = false;
				}
				that.$confirm(
					'此操作将修改该登录类型?', 
					'提示', 
					{
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.updateLoginType();
					}
				);
			},
			
			// 点击删除
			handleDeleteClick (obj) {
				this.delete_id = obj.id;
				this.delete_display = true;
			},
			// 点击删除弹出框确认按钮
			handleDeletePopupConfirmClick () {
				const that = this;
				that.loading = true;
				var requestData = {
					id: that.delete_id
				};
				Api.deleteLoginType(requestData).then((res) => {
					if (res.data.success) {
						that.do_msg = res.data.message;
						that.findProductType();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			
			/********************************* @Function *********************************/
			// 请求数据
			getList () {
				const that = this;
				that.loading = true;
				var requestData = {
					limit: 10,
					pageNum: that.currentPage
				};
				Api.findLoginType(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.tableData = [];
						that.total = res.data.data.totalItems;
						for (var i = 0;i < res.data.data.data.length;i++) {
							var _o = res.data.data.data[i];
							that.tableData.push({
								id: _o.id,
								name: _o.loginTypeName || '',
								productType: _o.type || 1,
								productName: that.mapProductTypetoName(_o.type),
								userType: _o.userType || 0,
								userTypeName: that.mapUserTypetoName(_o.userType),
								creatDate: BaseMethods.formatTime(_o.createTime),
								remark: _o.explain || '',
								clear: _o.isSchedulerDelete || 0,
								clearName: _o.isSchedulerDelete == 0 ? '否' : '是'
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 新增登录类型
			addLoginType () {
				const that = this;
				that.loading = true;
				var requestData = {
					appId: null,
					explain: that.add_remark,
					id: null,
					isSchedulerDelete: that.add_clear,
					loginTypeName: that.add_name,
					secretId: null,
					type: that.add_product_type,
					updateTime: null,
					userType: that.add_user_type
				};
				Api.addLoginType(requestData).then((res) => {
					if (res.data.success) {
						that.do_msg = res.data.message;
						that.findProductType();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 修改登录类型
			updateLoginType () {
				const that = this;
				that.loading = true;
				var requestData = {
					appId: null,
					explain: that.update_remark,
					id: that.update_id,
					isSchedulerDelete:  that.update_clear,
					loginTypeName:  that.update_name,
					secretId: null,
					type:  that.update_product_type,
					updateTime: null,
					userType: that.update_user_type
				};
				Api.updateLoginType(requestData).then((res) => {
					if (res.data.success) {
						that.do_msg = res.data.message;
						that.findProductType();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 把产品类别转换成名称
			mapProductTypetoName (type) {
				var result = '';
				switch (type) {
					case 1:
						result = 'pc端';
						break;
					case 2:
						result = 'app';
						break;
					case 3:
						result = '微信授权';
						break;
					case 4:
						result = '扫码获取随机二维码';
						break;
					case 5:
						result = '微信根据unionid登录';
						break;
					case 6:
						result = '解析令牌';
						break;
					case 7:
						result = '根据redis密令登录';
						break;
				}
				return result;
			},
			// 把用户类别转换成用户类别名称
			mapUserTypetoName (type) {
				var result = '';
				switch (type) {
					case 0:
						result = '患者';
						break;
					case 1:
						result = '非患者';
						break;
				}
				return result;
			},
			// 获取产品类型
			findProductType() {
				const that = this;
				var _requestData = {};
				Api.findProductType(_requestData).then((res) => {
					if (res.data.success) {
						let products = [];
						let mission = [];
						res.data.data.forEach((v) => {
							let _isBe = false;
							products.forEach((fv) => {
								if (fv.id == v.productId) {
									_isBe = true;
									v.missionId && fv.child.push({
										missionId: v.missionId,
										missionName: v.missionName
									});
								}
							});
							!_isBe && products.push({
								id: v.productId,
								name: v.productName,
								child: v.missionId ? [{
									missionId: v.missionId,
									missionName: v.missionName
								}]
								: []
							});
							mission.push({
								id: v.missionId,
								name: v.missionName
							});
						});
						// console.log(_list);
						that.setAllProduct(products);
						that.setMission(mission);
						that.findAuthProduct();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取登录者产品
			findAuthProduct() {
				const that = this;
				var _requestData = {};
				Api.findAuthProduct(_requestData).then((res) => {
					if (res.data.success) {
						var _list = [];
						res.data.data && res.data.data.forEach((v) => {
							_list.push({
								id: v.productId,
								name: v.productName
							});
						});
						// console.log(_list);
						that.setAuthProduct(_list);
						that.loading = false;
						that.add_display = false;
						that.update_display = false;
						that.$message.success(that.do_msg);
						that.getList();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			
			...mapMutations({
				'setAllProduct': 'setAllProduct',
				'setMission': 'setMission',
				'setAuthProduct': 'setAuthProduct'
			})
		}
	}
</script>

<style scoped>
	.back_tools_manage{ position: relative;width: 100%;height: 100%;padding: 15px; }
	.back_tools_manage .scroller{ width: 100%;height: 100%;padding: 15px;background: #fff;overflow-x: hidden;overflow-y: auto; }
</style>
